
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class WalletDeposit extends Vue {
  public dialog = false;
  public formTitle = 'واریز وجه';
  public desserts = [];
  public companyId = 0;
  public companies = [];
  public walletDepositTypes = [
    { id: 1, name: 'شارژ توسط مدیر' },
    { id: 2, name: 'واریز در حساب بانکی' }
  ];
  public headers = [
    { text: 'شماره پیگیری', value: 'id' },
    { text: 'نام شرکت', value: 'company' },
    { text: 'تاریخ', value: 'transactionDate' },
    { text: 'مبلغ', value: 'amount' },
    { text: 'توضیحات', value: 'description' },
    { text: 'وضعیت', value: 'walletTransferStatus' },
    { text: '', value: 'action', sortable: false }
  ];
  public editedItem = {
    id: 0,
    companyId: 0,
    amount: 0,
    description: ''
  };
  public defaultItem = {
    id: 0,
    companyId: 0,
    amount: 0,
    description: ''
  };
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'واریز وجه',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getCompanyShortList().then((response: any) => {
      this.companies = response.data;
      this.$hideLoading();
    });
    this.$nextTick(async () => {
      await this.updateTransaction();
    });
  }

  async updateTransaction() {
    this.$showLoading();
    await Api.getWalletDeposits(this.companyId).then((response: any) => {
      this.desserts = response.data;
      this.$hideLoading();
    });
  }

  async save() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.createWalletDeposit(this.editedItem).then((response: any) => {
      this.$showNotification('success', 'درخواست با موفقیت ثبت شد.');
      this.close();
      this.$hideLoading();
    });
  }

  async reset() {
    this.companyId = 0;
    this.$nextTick(async () => {
      await this.updateTransaction();
    });
  }

  async close() {
    this.dialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    await this.initialize();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  getColor(walletBankTransferStatus: string) {
    if (walletBankTransferStatus === 'تائید شده') {
      return 'green secondary-4';
    } else {
      return 'red secondary-4';
    }
  }
}
